import cx from 'classnames';
import { bool } from 'prop-types';
import React from 'react';

/** @param {{ hideOnMobile?: boolean }} props */
const BlockHr = ({ hideOnMobile }) => (
  <hr
    className={cx(
      'mx-m',
      'my-l',
      hideOnMobile && 'hidden md:block',
      'md:my-xl md:mx-auto md:w-[42.5rem]'
    )}
  />
);

BlockHr.propTypes = {
  hideOnMobile: bool,
};

export default BlockHr;
